export const ROUTE_NAMES = {
    OVERVIEW: 'overview',
    USER: {
        PROFILE: "user_profile",
    },
    LOGIN: 'login',
    FORBIDDEN: 'forbidden',
    DEPOT: {
        OVERVIEW: 'depot_overview',
        CLIENTS: {
            OVERVIEW: 'depot_clients_overview'
        },
        COMPANY: {
            VIEW_COMPANY: 'depot_company_view_company',
            VIEW_SITES: 'depot_company_view_sites',
            RENAME_COMPANY: 'depot_company_rename_company',
            SITES: {
                VIEW_SITE: 'depot_company_sites_view_site',
                RENAME_SITE: 'depot_company_sites_rename_site'
            }
        },
        COMPANIES: {
            DASHBOARD: 'depot_companies_dashboard',
            OVERVIEW: 'depot_companies_overview',
            BROWSE: 'depot_companies_browse',
            BROWSE_LETTER: 'depot_companies_browse_letter',
            ADD_COMPANY: 'depot_companies_add_company',
            FIX_SITE_NAMING: 'depot_companies_fix_site_naming',
            DEDUPE_SITES: 'depot_companies_dedupe_sites',
            SYNC_PROFILE_OWNERSHIP: 'depot_companies_sync_profile_ownership'
        },
        SECTORS: {
            DASHBOARD: 'depot_sectors_dashboard',
            OVERVIEW: 'depot_sectors_overview',
            ADD_SECTOR: 'depot_sectors_add_sector'
        },
        REVIEW: {
            VIEW_REVIEW: 'depot_review_view_review'
        },
        REVIEWS: {
            DASHBOARD: 'depot_reviews_dashboard',
            OVERVIEW: 'depot_reviews_overview',
            INSIGHTS: 'depot_reviews_insights'
        },
        SCHEDULES: {
            OVERVIEW: 'depot_schedules_overview',
            ALL_JOBS: 'depot_schedules_all_jobs',
            VIEW_SCHEDULE: 'depot_schedules_view_schedule'
        },
        FETCH_RESPONSE_PROFILES: {
            OVERVIEW: 'depot_fetch_response_profiles_overview',
            ALL_PROFILES: 'depot_fetch_response_profiles_all_profiles',
            VIEW_PROFILE: 'depot_fetch_response_profiles_view_profile'
        },
        SITES: {
            OVERVIEW: 'depot_sites_overview',
            SEARCH: 'depot_sites_search'
        },
        PROFILE: {
            VIEW_PROFILE: 'depot_profile_view_profile',
            VIEW_REVIEWS: 'depot_profile_view_reviews'
        },
        PROFILES: {
            OVERVIEW: 'depot_profiles_overview',
            VIEW_PROFILES: 'depot_profiles_view_profiles',
            CHANNELS: 'depot_profiles_channels',
            ADD_PROFILE: 'depot_profiles_add_profile',
            BULK_ADD_PROFILES: 'depot_profiles_bulk_add_profiles',
            ENRICH_PROFILES_LIST: 'depot_profiles_enrich_profiles_list',
            REBUILD_REVIEW_COUNTS: 'depot_profiles_rebuild_review_counts'
        },
        AGGREGATIONS: {
            OVERVIEW: 'depot_aggregations_overview',
            SEARCH: 'depot_aggregations_search',
            VS: 'depot_aggregations_vs'
        },
        PLACE_DETAILS: {
            OVERVIEW: 'depot_place_details_overview',
            SEARCH: 'depot_place_details_search',
            MAP: 'depot_place_details_map',
            REFRESH: 'depot_place_details_refresh',
            BACKFILL: 'depot_place_details_backfill',
            VALIDATE_CSV: 'depot_place_details_validate_csv',
            IMPORT_CSV: 'depot_place_details_import_csv',
            GOOGLE_LOOKUP: 'depot_place_details_google_lookup',
            VIEW: 'depot_place_details_view'
        },
        SERVICE_BUS: {
            OVERVIEW: 'depot_service_bus_overview',
            QUEUE_MESSAGES: 'depot_service_bus_queue_messages',
            TOPIC_SUBSCRIPTIONS: 'depot_service_bus_topic_subscriptions',
            SUBSCRIPTION_MESSAGES: 'depot_service_bus_subscription_messages'
        },
        AUDIT: {
            OVERVIEW: 'depot_audit_overview'
        }
    },
    MANTLE: {
        OVERVIEW: 'mantle_overview'
    },
    ONETWOFIVEDATA: {
        OVERVIEW: '125data_overview',
        CHAT: {
            DASHBOARD: {
                OVERVIEW: '125data_chat_dashboard_overview',
                DASHBOARD_THREAD: '125data_chat_dashboard_thread',
                DASHBOARD_CHAT: '125data_chat_dashboard_chat'
            },
            FAQS: {
                OVERVIEW: '125data_chat_faqs_overview',
                FAQS_THREAD: '125data_chat_faqs_thread',
                FAQS_CHAT: '125data_chat_faqs_chat'
            },
            OVERVIEW: '125data_chat',
        },
        COMPANIES: {
            OVERVIEW: '125data_companies_overview',
            VIEW_COMPANY: '125data_companies_view_company'
        },
        LISTINGS: {
            OVERVIEW: '125data_listings_overview',
            GOOGLE_LOCATIONS: '125data_listings_google_locations'
        },
        SNIPPETS: {
            OVERVIEW: '125data_snippets_overview'
        },
        FEEDBACK: {
            // The section hub, matching REPORTS.OVERVIEW and CHAT.OVERVIEW. The browse
            // page it used to name is now BROWSE.
            OVERVIEW: '125data_feedback_overview',
            BROWSE: '125data_feedback_browse',
            TOP_COMMENTS: '125data_feedback_top_comments'
        },
        REPORTS: {
            OVERVIEW: '125data_reports_overview',
            CATALOGUE: '125data_reports_catalogue',
            BUILDER: '125data_reports_builder'
        },
        INTEGRATIONS: {
            OVERVIEW: '125data_integrations_overview',
            LIST: '125data_integrations_list',
            VIEW: '125data_integrations_view',
            NEW: '125data_integrations_new',
            TEMPLATES: '125data_integrations_templates'
        }
    }
};

export const HTTP_TYPES = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE'
};
